/**
 * servicios menus y contenido
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * Contact: csgj@gft.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { InlineResponse20015 } from '../model/inlineResponse20015';
import { InlineResponse20016 } from '../model/inlineResponse20016';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class ArticlesService {
  protected basePath = environment.apiUrl + environment.apiEnv;
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   * Obtiene los articulos
   * @param lang
   * @param paginator
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public articlesGet(lang: string, paginator: string, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse20015>;
  public articlesGet(lang: string, paginator: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse20015>>;
  public articlesGet(lang: string, paginator: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse20015>>;
  public articlesGet(lang: string, paginator: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (lang === null || lang === undefined) {
      throw new Error('Required parameter lang was null or undefined when calling articlesGet.');
    }

    if (paginator === null || paginator === undefined) {
      throw new Error('Required parameter paginator was null or undefined when calling articlesGet.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (lang !== undefined && lang !== null) {
      queryParameters = queryParameters.set('lang', <any>lang);
    }
    if (paginator !== undefined && paginator !== null) {
      queryParameters = queryParameters.set('paginator', <any>paginator);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<InlineResponse20015>('get', `${this.basePath}/articles`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   *
   * Devuelve un articulo
   * @param lang
   * @param slug
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public searcharticleGet(lang: string, slug: string, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse20016>;
  public searcharticleGet(lang: string, slug: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse20016>>;
  public searcharticleGet(lang: string, slug: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse20016>>;
  public searcharticleGet(lang: string, slug: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (lang === null || lang === undefined) {
      throw new Error('Required parameter lang was null or undefined when calling searcharticleGet.');
    }

    if (slug === null || slug === undefined) {
      throw new Error('Required parameter slug was null or undefined when calling searcharticleGet.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (lang !== undefined && lang !== null) {
      queryParameters = queryParameters.set('lang', <any>lang);
    }
    if (slug !== undefined && slug !== null) {
      queryParameters = queryParameters.set('slug', <any>slug);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<InlineResponse20016>('get', `${this.basePath}/searcharticle`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }
}
